import axios from 'axios';
import GlobalStoreHelper from './GlobalStoreHelper';
import CartActions from './CartActions';

export default class StoreModal {

    /**
     * Open the store selector modal
     * @return {void}
     */
    static toggleStoreSelector(productId = null) {
        const modal = document.getElementById('list-of-stores-wrap');
        !GlobalStoreHelper.ifStoreSelected() ? modal.classList.add('first-load') : modal.classList.remove('first-load');
        if(modal.classList.contains('visible') && !GlobalStoreHelper.ifStoreSelected()) return;

        if (modal.classList.contains('visible')){
            modal.classList.remove('visible');
            return;
        } else {
            // Autohide mobile menu
            const mobileMenu = document.querySelector('#off-canvas-nav');
            if (mobileMenu.classList.contains('active')) {
                document.querySelector('.off-canvas-nav').click();
            }
            modal.classList.add('visible');
            StoreModal.loadStoreLocations(null, productId);
        }
    }

    /**
     * Trigger fold/unfold of the additional information block on store selector
     * @param event
     */
    static showMoreInfo(event = null) {
        const clickedAt = event.target;
        const parentBlock = clickedAt.parentElement.parentElement;
        const infoBlock = parentBlock.querySelector('.more-info-fold')
        const classList = infoBlock.classList;
        if (classList.contains('d-none')) {
            classList.remove('d-none');
            parentBlock.classList.add('open');
        } else {
            classList.add('d-none');
            parentBlock.classList.remove('open');
        }
    }

    /**
     * Formats store information and populates store selector results
     * @param dom store modal element
     * @param response location information
     */
    static formatStoreInfo(dom, response) {
        const { settings } = response;
        if (!settings) return

        if (settings.manager) {
            const wrapClass = dom.querySelector('.more-info-fold .management').classList;
            const managerField = dom.querySelector('.more-info-fold .management span');
            managerField.innerHTML = settings.manager;
            wrapClass.remove('d-none');
        }

        if (settings.phone && settings.showPhoneNumber) {
            const wrapClass = dom.querySelector('.more-info-fold .phone').classList;
            const managerField = dom.querySelector('.more-info-fold .phone span');
            managerField.innerHTML = settings.phone;
            wrapClass.remove('d-none');
        }

        if (settings.email) {
            const wrapClass = dom.querySelector('.more-info-fold .email').classList;
            const managerField = dom.querySelector('.more-info-fold .email a');
            const emailField = dom.querySelector('.promise-email-container .email a');
            managerField.innerHTML = settings.email;
            managerField.href = `mailto:${settings.email}`
            wrapClass.remove('d-none');

            emailField.innerHTML = settings.email;
            emailField.href = `mailto:${settings.email}`;
        }
    }

    /**
     * Formats and outputs exception work hours
     * @param dom store modal element
     * @param response location information
     */
    static formatHolidays(dom, response) {
        const { settings } = response;
        if (!settings) return

        if (settings.exceptionDates?.length > 0) {
            const wrapClass = dom.querySelector('.more-info-fold .special-hours').classList;
            wrapClass.remove('d-none');
            const container = dom.querySelector('.more-info-fold .special-hours .hour-list');
            const holidayText = container.dataset.holidayText;

            for (let i = 0; i < settings.exceptionDates?.length; i++) {
                const exception = settings.exceptionDates[i];
                const para = document.createElement('div');
                const bold = document.createElement('b');
                const date = new Date(exception.date);
                const dateString = `(${date.getDate()}/${('0' + (date.getMonth() + 1)).slice(-2)})`;
                bold.innerHTML = `${exception.title} ${dateString}&nbsp-&nbsp;`;
                const span = document.createElement('span');
                if (exception.isFullDayHoliday) {
                    span.innerHTML = holidayText;
                } else {
                    span.innerHTML = `${exception.startTime} a ${exception.endTime}`;
                }
                para.appendChild(bold);
                para.appendChild(span);
                container.appendChild(para);
            }
        }
    }

    static formatWorkHoursFirstLoad(dom, response) {
        const { settings } = response;
        if (!settings) return

        if (settings.start1 && settings.end1) {
            const days = ["L", "M", "X", "J", "V", "S", "D"];

            let startingDay = null;
            let sameOutput = null;
            let textWorkHours = "";
            for (let i = 0; i < 7; i++) {
                let hourString = this.formatHourOutput(settings['start' + (i + 1)], settings['end' + (i + 1)]).replaceAll(' ', '');

                if (sameOutput === null) {
                    sameOutput = hourString;
                    startingDay = i;
                } else if (sameOutput !== hourString || i === 6) {
                    if (startingDay < i - 1) {
                        if (sameOutput === hourString) {
                            textWorkHours += `${days[startingDay]}-${days[i]}: ${sameOutput} - `;
                        } else {
                            textWorkHours += `${days[startingDay]}-${days[i - 1]}: ${sameOutput} - `;
                        }
                    } else if (sameOutput === hourString && i === 6) {
                        textWorkHours += `${days[startingDay]}-${days[i]}: ${hourString} - `;
                    } else {
                        textWorkHours += `${days[startingDay]}: ${sameOutput} - `;
                    }

                    if (sameOutput !== hourString && i === 6) {
                        textWorkHours += `${days[i]}: ${hourString} - `;
                    }

                    startingDay = i;
                    sameOutput = hourString;
                }
            }

            textWorkHours = textWorkHours.slice(0, textWorkHours.length - 3);
            textWorkHours = "Horarios " + textWorkHours;
            dom.innerHTML += `<div class="info-work-hours">${textWorkHours}</div>`
        }
    }

    /**
     * Format opening and closing hours with day grouping for each of the stores
     * @param dom
     * @param response
     */
    static formatWorkHours(dom, response) {
        const { settings } = response;
        if (!settings) return

        if (settings.start1 && settings.end1) {
            const wrapClass = dom.querySelector('.more-info-fold .regular-hours').classList;
            const container = dom.querySelector('.more-info-fold .regular-hours .hour-list');
            const days = [
                container.dataset.monday,
                container.dataset.tuesday,
                container.dataset.wednesday,
                container.dataset.thursday,
                container.dataset.friday,
                container.dataset.saturday,
                container.dataset.sunday,
            ];
            wrapClass.remove('d-none');

            let startingDay = null;
            let sameOutput = null;
            for (let i = 0; i < 7; i++) {
                const hourString = this.formatHourOutput(settings['start' + (i + 1)], settings['end' + (i + 1)]);

                if (sameOutput === null) {
                    sameOutput = hourString;
                    startingDay = i;
                    // ... next
                } else if (sameOutput !== hourString || i === 6) {
                    // output prev day
                    const hours = document.createElement('div');
                    const bold = document.createElement('b');
                    const span = document.createElement('span');
                    span.innerHTML = sameOutput;

                    if (startingDay < i - 1) {
                        if (sameOutput === hourString) {
                            bold.innerHTML = `${days[startingDay]} a ${days[i]}&nbsp;-&nbsp;`;
                        } else {
                            bold.innerHTML = `${days[startingDay]} a ${days[i - 1]}&nbsp;-&nbsp;`;
                        }
                    } else if (sameOutput === hourString && i === 6) {
                        bold.innerHTML = `${days[startingDay]} a ${days[i]}&nbsp;-&nbsp;`;
                    } else {
                        bold.innerHTML = `${days[startingDay]}&nbsp;-&nbsp;`;
                    }

                    hours.appendChild(bold);
                    hours.appendChild(span);
                    container.append(hours);

                    // For Sunday in case it does not match with previous day
                    if (sameOutput !== hourString && i === 6) {
                        const hours = document.createElement('div');
                        const bold = document.createElement('b');
                        const span = document.createElement('span');
                        span.innerHTML = hourString;
                        bold.innerHTML = `${days[i]}&nbsp;-&nbsp;`;
                        hours.appendChild(bold);
                        hours.appendChild(span);
                        container.append(hours);
                    }

                    startingDay = i;
                    sameOutput = hourString;
                }
            }
        }
    }

    /**
     * Removes leading zero from hours
     * @param startHours string
     * @param endHours string
     * @returns {string}
     */
    static formatHourOutput(startHours, endHours) {
        let start = startHours;
        let end = endHours;

        const container = document.querySelector('.more-info-fold .special-hours .hour-list');
        const holidayText = container.dataset.holidayText;

        if (startHours.indexOf('0') === 0) {
            start = startHours.substring(1);
        }
        if (endHours.indexOf('0') === 0) {
            end = endHours.substring(1);
        }

        if (startHours !== '00:00' && endHours !== '00:00') {
            return `${start} - ${end}`;
        } else {
            return holidayText;
        }
    }

    /**
     * Load store locations and populate modal with them for user selection
     */
    static async loadStoreLocations(event = null, productId = null) {
        if (event) event.preventDefault();

        const configItems = await GlobalStoreHelper.getConfigItems();
        let showMultipleItemStockMessage = false;
        const currentLocation = GlobalStoreHelper.getItem('locationId')
        const modal = document.getElementById('list-of-stores-wrap');
        const container = modal.querySelector(".store-list-wrap .store-list");
        StoreModal.toggleLoader(true);

        const data = await (async () => {
            if(configItems.defaultStoreSelection === 'true'){
                const zipCode = modal.querySelector('#search-wrap input').value;
                const { location } = await StoreModal.getGPSCoords(zipCode);

                const { data } = await axios.post('/apps/storeselector/api/store-distances', {
                    latitude: location.lat,
                    longitude: location.lng
                });

                return data.sort((a,b) => a.location.order - b.location.order);
            }else{
                const locations = GlobalStoreHelper.updateStoreInfo(await GlobalStoreHelper.request({ service: `locations/pickups`, cache: true }))
                return locations.sort((a,b) => a.settings.order - b.settings.order);
            }
        })();

        const storeKeyLocations = {}
        const isMobile = window.innerWidth < 575
        
        for (const loc of data) { storeKeyLocations[loc.id] =  GlobalStoreHelper.updateStoreInfo(loc) }
        GlobalStoreHelper.setItem('locations', storeKeyLocations);
        
        const productPage = document.getElementsByTagName('body')[0].classList.contains('template-product');
        const isCollectionPage = (window.location.href.includes("collections") || window.location.href.includes("search-results-page")) && !window.location.href.includes("products");
        const isCartPage = !!window.location.href.includes('cart');

        let peninsulaStockTag;
        let warehouseTag;
        let noEnvioTag;

        if(productPage) {
            warehouseTag = JSON.parse(document.querySelector('.free-shipping-message')?.dataset.warehouseTag || "false");
            peninsulaStockTag = JSON.parse(document.querySelector('.free-shipping-message').dataset.peninsulaStockTag);
            noEnvioTag = !!window.product_tags?.match(/(?:^|,)\s*no_envio\s*(?:,|$)/);
        } else if(isCollectionPage && productId) {
            const productCard = document.querySelector(`#snize-product-${productId}`);
            const tags = Array.from(productCard.classList).reduce((prev, current) => {
                if(current.includes('tag')) {
                    const tag = current.replace('snize-product-tag','');

                    prev.push(tag);
                }

                return prev
            },[]);

            warehouseTag = !!tags.find((tag) => tag.includes('warehouse-15'));
            peninsulaStockTag = !!tags.find((tag) => tag.includes('peninsula-stock'));
            noEnvioTag = !!tags.find((tag) => tag === '-no_envio');
        }

        const cartPage = document.getElementsByTagName('body')[0].classList.contains('template-cart');
        const cachedProductStock = productPage || productId ? await GlobalStoreHelper.getCachedStock(productId) : null;
        const cartProductInfo = cartPage ? await CartActions.fetchMultipleProductLocations() : null;
        const firstLoad = document.querySelector('.first-load');

        const { ordersMultiLocation } = GlobalStoreHelper.getItem('configKey')
        let locationsWithStock = [];
        let lastMessage = null;

        if(ordersMultiLocation && cartProductInfo) {
            Object.entries(cartProductInfo).forEach(([key, value]) => {
                value.forEach((location) => {
                    if(location?.quantity > 0)
                        locationsWithStock.push(key);
                });
            });
        }

        const safeStockTags = document.querySelector(`[data-safe-stock-tags-${productId}]`)?.dataset[`safeStockTags-${productId}`]?.split(',').map((tag) => {
            if(tag.includes('_')) {
                const [_,storeName] = tag.split('_');
                return  storeName?.trim();
            } else
                return tag;

        }).filter((tag) => tag);

        for (let i = 0; i < data.length; i++) {
            try {
                const result = data[i];
                const isSelectedStore = result?.id === currentLocation;
                const parkingInformation = result?.settings?.parkingInformation;
                const originDom = document.querySelector('.loction-entry-template .location-entry');
                const clonedDom = originDom.cloneNode(true);
                const isWareHouse15 = result?.settings?.wareHouse15
                const selectButton = clonedDom.querySelector('.selection-btn.ready-for-selection');
                const storeNameEl = clonedDom.querySelector('h4');

                if(isMobile) {
                    const selectButton = document.querySelector(".selection-btn.ready-for-selection");
        
                    selectButton.innerHTML = "Seleccionar";

                    result.name = result.name.replace(/MediaMarkt(.*S.C.|)/,"")
                }

                if (isSelectedStore) {
                    clonedDom.querySelector('.distance-wrap').classList.add('hide');
                    const button = clonedDom.querySelector('.selection-btn.existing-selection');
                    button.classList.add('shown');
                    button.dataset.id = result.id;
                    selectButton.classList.remove('shown');
                } else {
                    clonedDom.querySelector('.distance').innerHTML = result.distance;
                    clonedDom.querySelector('.distance-wrap').classList.remove('hide');
                    const button = selectButton;
                    button.classList.add('shown');
                    button.dataset.id = result.id;
                    clonedDom.querySelector('.selection-btn.existing-selection').classList.remove('shown');
                }

                if(parkingInformation && currentLocation) {
                    const divParking = document.createElement("div");
                    divParking.classList.add('parking-information');
                    divParking.innerHTML = parkingInformation;
                    clonedDom.querySelector('.selection-btn-container').appendChild(divParking);
                }

                storeNameEl.innerHTML = result.name;

                if (firstLoad) {
                    StoreModal.formatWorkHoursFirstLoad(clonedDom, result);
                } else {
                    clonedDom.querySelector('.address-lines').innerHTML = GlobalStoreHelper.combineAddress(result)
                    const directionsUrl = `https://www.google.com/maps/dir/${result.settings?.latitude},${result.settings?.longitude}`;
                    clonedDom.querySelector('a.show-directions').href = directionsUrl;

                    StoreModal.formatWorkHours(clonedDom, result);
                    StoreModal.formatHolidays(clonedDom, result);
                    StoreModal.formatStoreInfo(clonedDom, result);

                    let stockAtLocation = null;
                    if (cachedProductStock) {
                        stockAtLocation = cachedProductStock.filter(
                            (loc) => loc.locationId === result?.id
                        );
                    }

                    if (cartProductInfo) {
                        stockAtLocation = cartProductInfo[result?.id];
                        stockAtLocation.sort((a, b) => (a.quantity > b.quantity) ? 1 : -1);
                    }

                    if (stockAtLocation) {
                        if (stockAtLocation.length > 1) {
                            showMultipleItemStockMessage = true;
                        }

                        let cartProductInfoFormatted = [];

                        if (cartProductInfo && typeof cartProductInfo === 'object') {
                            cartProductInfoFormatted = GlobalStoreHelper.formatBatchPromiseRequest(cartProductInfo);
                        }

                        const labelInfos = { online: null, store: null };

                        const getLabel = async (stockInfo) => {
                            const labelInfo = await GlobalStoreHelper.createPromiseObject(stockInfo, {
                                locationId: result.id,
                                smallDate: false,
                                newLine: false,
                                addStoreSelector: false,
                                storeSelectorModal: true,
                                locSelectedIsWarehouse15: isWareHouse15,
                                isModal: true,
                                ...(peninsulaStockTag !== undefined && { peninsulaStockTag }),
                                ...(warehouseTag !== undefined && { warehouseTag }),
                                ...(noEnvioTag !== undefined && { noEnvioTag }),
                            });

                            return labelInfo
                        }

                        if(cachedProductStock) {
                            const { online, store } = await getLabel(cachedProductStock) || {};

                            labelInfos.online = online || {};
                            labelInfos.store = store || {};
                        } else {
                            cartProductInfoFormatted = cartProductInfoFormatted.reduce((prev, current) => {
                                const { productId } = current;

                                prev[productId] = prev[productId] || [];

                                prev[productId].push(current);

                                return prev;
                            }, []);

                            cartProductInfoFormatted = Object.entries(cartProductInfoFormatted).map(([_key, value]) => value);

                            await Promise.all(cartProductInfoFormatted.map(async (stockInfo) => {

                                const labelInfo = await getLabel(stockInfo);

                                // Set the promises to highest date promise for delivery method title output
                                if (!labelInfos.online || new Date(labelInfo.online.date) > labelInfos.online.date) {
                                    labelInfos.online = labelInfo.online;
                                }
                                if (!labelInfos.store || new Date(labelInfo.store.date) > labelInfos.store.date) {
                                    labelInfos.store = labelInfo.store;
                                }

                            }))
                        }

                        let availability = '';

                        if (labelInfos.store.color === 'grey') {
                            availability = lastMessage || `
                                <div class="bubble ${labelInfos.store.color}"></div>
                                <div class="stock-label">${labelInfos.store.message}</div>
                            `;
                        } else {
                            availability = `
                                <div class="bubble ${labelInfos.store.color}"></div>
                                <div class="stock-label">${labelInfos.store.message}</div>
                            `;
                        }

                        if(ordersMultiLocation && locationsWithStock.length > 0 && labelInfos.store.color !== 'grey' && labelInfos.store.message !== 'Recogida en tienda en 30min') {
                            lastMessage = availability;
                        }

                        clonedDom.querySelector('.stock-status.mobile').innerHTML = availability;
                        clonedDom.querySelector('.stock-status.desktop').innerHTML = availability;
                    }
                }

                const totalStock = cachedProductStock?.reduce((prev, productStock) => {
                    prev += productStock.quantity;

                    return prev;
                }, 0);

                if(!totalStock && safeStockTags?.length && safeStockTags.find((tag) => result.location.name.includes(tag))) {
                    clonedDom.querySelectorAll('.stock-label').forEach((label) => label.innerHTML = window.check_disponibility_label_modal);
                    clonedDom.querySelectorAll('.bubble').forEach((bubble) => (bubble.classList.replace('grey','orange'), bubble.classList.replace('green','orange')));

                    const email = clonedDom.querySelector('.safe-stock-email.email');

                    if(email?.querySelector("a")?.innerText) {
                        email?.classList.remove("d-none");
                    }
                }

                container.appendChild(clonedDom);
            } catch (error) {
                console.log(error);
            }
        }

        // Show that availability is calculated for all items in the cart
        if (showMultipleItemStockMessage) {
            document.querySelector('#list-of-stores-wrap .store-modal-error').classList.remove('d-none');
        } else {
            document.querySelector('#list-of-stores-wrap .store-modal-error').classList.add('d-none');
        }

        StoreModal.toggleLoader();
    }

    /**
     * Retrieve users GPS location either based on browser request or provided ZIP code
     * @param {number} zipCode optional zip code to get users coordinates for
     * @returns Google object containing lat lng values for GPS
     */
    static async getGPSCoords(zipCode = null) {
        const config = await GlobalStoreHelper.getConfigItems();
        if (zipCode) {
            const search = encodeURI(`${zipCode}`);
            const geocoder = new google.maps.Geocoder;
            const address = await geocoder.geocode({ address: search, region: 'ES' });
            const response = address.results.pop();
            return {
                location: {
                    lat: response.geometry.location.lat(),
                    lng: response.geometry.location.lng(),
                },
            }
        } else {
            let url = `https://www.googleapis.com/geolocation/v1/geolocate?key=${config.geocodingApiKey}`;
            const response = await axios.post(url, {});
            return response.data;
        }
    }


    /**
     * Displays the loader in modal window
     * @param {boolean} forceShow Whether to show loader no matter what
     * @returns void
     */
    static toggleLoader(forceShow = false) {
        const modal = document.getElementById('list-of-stores-wrap');
        const container = modal.querySelector(".store-list-wrap .store-list");
        const loader = modal.querySelector('.loader');

        if (loader.classList.contains('visible') && !forceShow) {
            loader.classList.remove('visible');
            return;
        } else {
            loader.classList.add('visible');
            container.innerHTML = '';
        }
    }

    /**
     * Store new locationId in session, close modal and update references on the website
     * to currently selected store.
     * @param {object} ev HTML DOM user clicked on
     */
    static async selectStore(ev) {
        const locationId = ev.dataset.id;
        GlobalStoreHelper.setItem('locationId', locationId);
        GlobalStoreHelper.setItem('firstLoadKey', true);
        StoreModal.toggleStoreSelector();
        await GlobalStoreHelper.fetchAndInitDefaultStore();
        GlobalStoreHelper.updateStoreNames();
        CartActions.fetchStockInfo();

        const body = document.getElementsByTagName('body')[0];
        if (body && (body.classList.contains('snize-results-page') || body.classList.contains('template-collection'))) {
            window.storePickup.ifStoreSelected() && window.storePickup.collectionPage.outputStockInfo();
            window.location.reload();
        }
    }
}
